"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classUtils = require("../../utils/classUtils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var defaultMember = {
  email: "",
  first_name: "",
  last_name: "",
  links: {
    admin_redirect: ""
  },
  member_key: "",
  member_role: "member",
  member_status: "",
  program_key: "",
  organization_key: "",
  member_registered: false
};
var searchablePropertyNames = ["first_name", "last_name", "email", "member_key", "full_name"];
var Member = exports.default = /*#__PURE__*/_createClass(function Member() {
  var _this = this;
  var memberValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultMember;
  _classCallCheck(this, Member);
  _defineProperty(this, "getDefaultInstance", function () {
    return defaultMember;
  });
  _defineProperty(this, "setInstanceValues", _classUtils.setInstanceValues.bind(this));
  this.setInstanceValues(memberValues);
  this.searchableProperties = searchablePropertyNames.reduce(function (searchableProperties, prop) {
    var node = {};
    if (prop === "full_name") {
      // create a full name prop so it can be searched as a such
      node[prop] = "".concat(_this.first_name.toLocaleLowerCase() || "", " ").concat(_this.last_name.toLocaleLowerCase() || "");
    } else {
      node[prop] = _this[prop].toLocaleLowerCase();
    }
    return _objectSpread(_objectSpread({}, searchableProperties), node);
  }, {});
  var searchableValues = Object.values(this.searchableProperties);
  this.includes = function (searchValue) {
    var searchQuery = searchValue.toLocaleLowerCase();
    return searchableValues.some(function (prop) {
      return prop.includes(searchQuery);
    });
  };
});